// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2aqvf","filesListContainer":"PosDisputesFiles_filesListContainer__tGA7h","filesButton":"PosDisputesFiles_filesButton__3Vf0x"};